// extracted by mini-css-extract-plugin
module.exports = {"root":"Badges_root__ZWDGf","timeIcon":"Badges_timeIcon__2VdMz","datetime":"Badges_datetime__l_W__"};